module.exports = __webpack_public_path__ + "static/logo-f1a36e511910847c6e27e7beb994f9df.png";